import React from 'react'
import { X } from 'react-feather'
import { PartnerPopupForm } from './partner-popup-form'
import { PartnerPopupSelect } from './partner-popup-select'

const PartnerPopup = ({onClose}) => {
  const [type, setType] = React.useState('select')

  const handleClose = (e) => {
    if(e){
      e.preventDefault()
      e.stopPropagation()
    }

    if(typeof onClose === 'function'){
      onClose(false)
    }
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center overflow-y-auto"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto my-10 lg:my-0" onClick={(e) => e.stopPropagation()}>
        <div className="w-full lg:w-8/12 mx-auto px-4 py-5 lg:px-8 lg:py-8 bg-white rounded">
          <div className="lg:w-auto mx-auto">

            <div className="flex justify-between items-center mb-5">
              <h1 className="text-lg lg:text-3xl text-left font-bold font-primary">
                Add Partner
              </h1>
              <X onClick={handleClose}/>
            </div>

            <hr className="mb-5 lg:mb-10"/>
            {
              type === 'select' &&
              <PartnerPopupSelect setType={setType}/>
            }
            {
              type === 'form' &&
              <div className="lg:w-3/4">
                <PartnerPopupForm handleClose={handleClose} />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export { PartnerPopup }
